module.exports = __webpack_public_path__ + "static/media/flyerPinamar.69bae74a.webp";